<script>
export default {
    name: "PatientVitals",

    data() {

        return {
            vitals: [],
        };
    },

    props: {

        patient: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchMFVitals(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchMFVitals() {

          let url = `MedicalFile/GetPatientMedicalFileVitalsForVisit`;
          url += `?PatientID=${this.patient.patienT_ID}`;
          url += `&VisitNo=${this.patient.visitNo}`;

          return this.$http
            .get(url)
            .then(({ data }) => {
              this.vitals = data;
            })
            .catch(() => {});
        },
    }
}
</script>
<template>
    <div class="w-full overflow-auto">
        <table class="table">
            <thead class="bg-blue-500 text-white text-sm">
              <tr class="flex w-full">
                <th class="p-tiny flex-1">Vitals</th>
                <th class="p-tiny flex-1">Time</th>
                <th class="p-tiny flex-1">Value</th>
              </tr>
            </thead>
            <tbody
              class="text-sm bg-gray-100 flex flex-col overflow-auto"
              style="max-height:35vh;"
            >
              <tr class="flex w-full" v-for="(vit, idx) in vitals" :key="idx">
                <td class="p-tiny flex-1">{{ vit.parameter }}</td>
                <td class="p-tiny flex-1">{{ vit.sysDate | dateFormatDT }}</td>
                <td class="p-tiny flex-1">{{ vit.value }}</td>
              </tr>
            </tbody>
        </table>
    </div>
</template>